export const calculateSlideCardColor = ({ slideNumber, theme }) => {
  let color;
  if (slideNumber === 0 || slideNumber === 3 || slideNumber === 6) {
    color = theme.palette.secondary.bundleCardFooterBackground;
  } else if (slideNumber === 1 || slideNumber === 4 || slideNumber === 7) {
    color = theme.palette.secondary.mobileActiveToggleBackground;
  } else if (slideNumber === 2 || slideNumber === 5 || slideNumber === 8) {
    color = theme.palette.secondary.bundleCardFooterBackground2;
  }
  return color;
};
